import Vue from 'vue'
import get from './get'

Vue.use(get)
